module.exports = require("@fortawesome/fontawesome-free/js/all.js");